import { TABS } from '@/enums';

export const EVENT_CURRENT_TAB_STORAGE_KEY = 'currentTab';

export const getStoredEventTab = () => {
  const storedTab = localStorage.getItem(EVENT_CURRENT_TAB_STORAGE_KEY);

  return Object.values(TABS).find((tab) => tab === storedTab) ?? TABS.DETAILS;
};
